// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-privacy[data-v-642574e8]{padding-top:101px;padding-bottom:100px}.p-privacy h2[data-v-642574e8]{font-size:1.375rem;padding-left:9px;border-left:2px solid #e03f19}@media (max-width:768px){.p-privacy h2[data-v-642574e8]{font-size:1rem}}.p-privacy p[data-v-642574e8]{font-weight:300;line-height:normal;letter-spacing:normal;word-wrap:break-word;word-break:normal}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
